import Chatcontainer from "./components/Chatcontainer";
import { ChatProvider } from "./newComponents2/ChatContextApi";

const ChatRoom = () => {
    return ( 
        <div className="chat-home">
            <div className="container">   
                <ChatProvider>
                     <Chatcontainer/>
                </ChatProvider>
            </div>
        </div>
     );
}
export default ChatRoom;